export default __webpack_public_path__ + "static/media/T160_RoHS.d6c5cbd9.pdf";